import axios from 'axios';
import SERVER_URL from './serverUrl';

const axiosInstance = axios.create({
    baseURL: SERVER_URL,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorCode = error.response?.data?.error;
    const shouldLogoutUser =
      errorCode === 'expired_token' || errorCode === 'invalid_token';
    if (shouldLogoutUser) {
      window.localStorage.removeItem('token'); 
      window.localStorage.removeItem('user');
      window.location = '/login';
    } 

    return Promise.reject(
      (error.response && error.response.data) ||
      'Something went wrong please try again.'
    );
  }
);

export default axiosInstance;
